import React, {useState, useEffect} from 'react';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import {numberToFraction, SportsBookLinks} from '../../utils/gameUtils';
import {isSafari} from 'react-device-detect';
import up from './images/up-signal.svg';
import down from './images/down-signal.svg';
import { useMediaQuery } from '@material-ui/core';
import { TwoValue } from '../TwoValue';

const styles = makeStyles(theme => ({
    valueContainer: {
        width: 86,
        borderRadius: 8,
        border: '1px solid #D1CFD7',
        height: 35,
        position: 'relative',
        "& p": {
            color: 'black !important',
        },
        [theme.breakpoints.up("sm")]: {
            borderRadius: 3,
            height: 30,
            width: 96,
            margin: '4px 0',
        },
        "& a": {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            color: '#272f3e',
            fontWeight: 400,
        },
        "& a:hover": {
            backgroundColor: '#eeeeff',
            borderColor: '#eeeeff',
        },
        "& a:active": {
            backgroundColor: '#074589',
            borderColor: '#074589',
            color: '#ffffff',
            fontWeight: 700,
            "& p": {
                color: 'white',
                fontWeight: 'bold'
            }
        }
    },
    odds: {
        fontSize: '14px',
        textAlign: 'center',
        margin: 0,
        lineHeight: '150%',
        letterSpacing: '0.3px',
        [theme.breakpoints.down('xs')]: {
            fontSize: '14px'
        }
    },
    bestLine: {
        border: '2px solid #FF8300AA'
    },
    pairsContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        [theme.breakpoints.up("sm")]: {
            height: '100%',
            justifyContent: 'center',
        },
    },
    noDataContainer: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: '30%',
        alignItems: 'center',
        '& h1': {
            fontSize: '14px',
            color: '#D3D3D3',
        }
    },
    upSignal: {
        position: 'absolute',
        top: -1,
        left: -1,
    },
    downSignal: {
        position: 'absolute',
        bottom: -2,
        right: -1,
    },
}));

export function OddsValue({game, bookName, bookData, marketFilter, margin}) {
    const classes = styles();
    const [showIndicator, setShowIndicator] = useState(false);

    useEffect(() => {
        if (!window.location.hostname.includes('odds.com')) {
            setShowIndicator(true);
        }
    }, []);

    const formatOdds = (outcome) => {
        let overUnderTotal;
        if (outcome['total'] !== undefined) {
            if (outcome['type'] === 'over') {
                overUnderTotal = 'o' + outcome['total'];
            } else {
                overUnderTotal = 'u' + outcome['total'];
            }
        }

        switch (marketFilter) {
            case 'spread':
                return <TwoValue firstValue={outcome['spread']} secondValue={outcome['odds']}/>;
            case '2way':
                return <TwoValue secondValue={outcome['odds']}/>;
            case 'total':
                return <TwoValue firstValue={overUnderTotal} secondValue={outcome['odds']}/>;
            default:
                return <TwoValue firstValue={outcome['spread']} secondValue={outcome['odds']}/>;
        }
    }

    if (!bookData) {
        return null;
    }

    return (
        <div className={`${classes.valueContainer}`} style={{margin: margin}}>
            <a href={SportsBookLinks[bookName]} target="blank">
                {formatOdds(bookData)}
            </a>
            {
                showIndicator && bookData?.odds_trend === 'up' && bookData.updated &&
                <img src={up} className={classes.upSignal} alt="up signal"/>
            }
            {
                showIndicator && bookData?.odds_trend === 'down' && bookData.updated &&
                <img src={down} className={classes.downSignal} alt="down signal"/>
            }
        </div>
    );
}


export function OddsValuePair({game, marketFilter, sportsBook}) {
    const classes = styles();

    const odds = game['markets'][marketFilter] || {};

    // Todo - need to be changed later
    const bookData = odds[sportsBook === 'BetRivers' ? 'SugarHouseNJ' : sportsBook];
    let homeBookData, awayBookData;

    if (bookData && bookData.length === 2) {
        // The response from the total market filter contains the under data as the first array elem
        if (marketFilter == 'total') {
            [awayBookData, homeBookData] = bookData;
        }
        else {
            [homeBookData, awayBookData] = bookData;
        }
    }

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

    return (
        <div className={classes.pairsContainer}>
            <OddsValue game={game} bookName={sportsBook} bookData={awayBookData} marketFilter={marketFilter} margin={isMobile ? '9px 0 8px' : ''}/>
            <OddsValue game={game} bookName={sportsBook} bookData={homeBookData} marketFilter={marketFilter}/>
        </div>
    )
}